module.exports = __webpack_public_path__ + "img/brand-volvo.512b6e25.png";